import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tela-contabeis',
  templateUrl: './tela-contabeis.component.html',
  styleUrls: ['./tela-contabeis.component.css']
})
export class TelaContabeisComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
